import { render, staticRenderFns } from "./TemplateAdministrator.vue?vue&type=template&id=7155448a&"
import script from "./TemplateAdministrator.vue?vue&type=script&lang=ts&"
export * from "./TemplateAdministrator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports